export const initialState = {
  height: '',
  weight: '',
  bloodPressure: '',
  dateObserved: null,
};
